import { Modals } from '@modules/husleie-framework/src/types/Modals.entity';
import type StaticDataState from '@modules/store/common/types/StaticDataState.entity';

export const state: StaticDataState = {
  loading: false,
  locale: '',
  language: '',
  timezone: '',
  translations: [],
  api: {
    errorStatus: {
      error: false,
      role: undefined,
    },
  },
  modal: {
    name: Modals.Null,
    open: false,
    closeable: false,
  },
};
